import React, { useState } from 'react';
import { TextField, Button, Typography, Container, CircularProgress, Alert } from '@mui/material';
import { styled } from '@mui/system';
import AxiosInstance from './Axios';
import { Link } from 'react-router-dom';

const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(4),
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await AxiosInstance.post('/Academy/api/forgot-password/', { email }, { timeout: 30000 });
      setSuccess(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ minHeight: 600 }}>
      <Typography variant="h4" align="center" gutterBottom sx={{ marginBottom: 2, marginTop: 10 }}>
        Forgot Password
      </Typography>

      {success ? (
        <Alert severity="success" sx={{ mt: 2 }}>
          If an account with that email exists, a password reset link has been sent. Please check your inbox.
        </Alert>
      ) : (
        <StyledForm onSubmit={handleSubmit}>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 2 }}>
            Enter your email address and we'll send you a link to reset your password.
          </Typography>
          <StyledTextField
            label="Email Address"
            type="email"
            variant="outlined"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && (
            <Typography variant="body2" color="error" align="center" gutterBottom>
              {error}
            </Typography>
          )}
          <StyledButton
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
            sx={{ paddingTop: 2, paddingBottom: 2 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Send Reset Link'}
          </StyledButton>
        </StyledForm>
      )}

      <Typography variant="body2" align="center" sx={{ mt: 3 }}>
        <Link to="/Login/" style={{ color: '#1976d2' }}>Back to Login</Link>
      </Typography>
    </Container>
  );
};

export default ForgotPassword;
